module.exports = __webpack_public_path__ + "img/img_cemiterio_ldc.15fe0439.png";